import {connect} from 'react-redux';

import {WorkspaceDisplayActionsEnum} from '../../../../libs/shared/core/src/models/tracking/contexts/workspaceTracking';
import {
  InterfaceEventsEnum,
  trackInterfaceEvent,
} from '../../../../libs/shared/core/src/services/tracking/tracking';
import {RWorkspaceFolderRootLabels} from '../../../models/api/workspaceModel';
import {hidePersonalWorkspaceRootFolderAsyncAction} from '../../../store/data/workspace/workspaceActions';
import {startedEditingWorkspacesAction} from '../../../store/panels/inboxes/inboxesPanelActions';
import {WorkspaceGenericItemContainerComponent} from './workspaceGenericItemContainerComponent';
import {workspaceItemMapStateToProps} from './workspaceItemContainerHelpers';

export const WorkspaceGenericItemContainer = connect(
  workspaceItemMapStateToProps,
  {
    startedEditingWorkspaces: startedEditingWorkspacesAction,
    hideWorkspaceRootFolder: hidePersonalWorkspaceRootFolderAsyncAction,
  },
  (stateProps, dispatchProps, ownProps) => {
    const {panelId, label, trackingSection} = ownProps;

    const onEditWorkspaces = () => {
      dispatchProps.startedEditingWorkspaces(panelId, stateProps.hasRarelyViewedItems);

      trackInterfaceEvent(InterfaceEventsEnum.P1_WORKSPACE_CLICK, {
        action: WorkspaceDisplayActionsEnum.VIEW_SIDEBAR,
        section: trackingSection,
      });
    };

    const onHideFromWorkspace = () => {
      if (label && RWorkspaceFolderRootLabels.is(label)) {
        dispatchProps.hideWorkspaceRootFolder(label);
      }
    };

    return {
      ...stateProps,
      ...ownProps,
      onEditWorkspaces,
      onHideFromWorkspace,
    };
  },
)(WorkspaceGenericItemContainerComponent);
